import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addNewReview } from '../../redux/Slices/ReviewsSlice'
import { useParams } from "react-router-dom";
import notify from "../UseNotification"

const UseRatePost = () => {

    const dispatch = useDispatch()
    const [rateText, setRateText] = useState("")
    const [rateValue, setRateValue] = useState("")
    const [loading, setLoading] = useState(true)
    let { id } = useParams();
    const { AddReview } = useSelector(state => state.ReviewsReducer)

    // change rate text
    const onChangeRateText = (e) => {
        setRateText(e.target.value)
    }
    // change rate value
    const onChangeReviewValue = (rateValue) => {
        setRateValue(rateValue)
    }

    // validate rate text on blur
    const ValidateRateText = (e) => {
        if (e.target.value === "") {
            notify("please, enter your review", "error")
        }
    }
    // validate
    const validate = () => {
        if (rateValue === "") {
            notify("please choose rate value", "error")
        }
        if (rateText === "") {
            notify("please type the rate text", "error")
        }
    }
    // onSubmit
    const Submit = async () => {
        validate();
        setLoading(true)
        await dispatch(addNewReview({
            prodId: id,
            formData: {
                review: rateText,
                rating: rateValue
            }
        }))
        setLoading(false)
    }

    useEffect(() => {
        if (loading === false) {
            if (AddReview.response) {
                if (AddReview.response.status && AddReview.response.status === 403) {
                    notify("Admin are not allow to add review", "error")
                }
                else if (AddReview.response.data) {
                    AddReview.response.data.errors.map(item => { return (notify(item.msg, "error")) })
                }
            }
            else if (AddReview.status && AddReview.status === 201) {
                notify("Your review added", "success")
                setTimeout(() => {
                    window.location.reload(false)
                }, 1500)
            }
        }
    }, [loading])

    return [onChangeReviewValue, rateText, onChangeRateText, Submit, ValidateRateText]
}

export default UseRatePost
